import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Heading from '../common/Heading';
import ActivityCard from './ActivityCard';
import imageActivityOne from '../../images/activity_image_1.jpg';
import imageActivityTwo from '../../images/activity_image_2.jpg';
import imageActivityThree from '../../images/activity_image_3.jpg';
import imageActivityFour from '../../images/activity_image_4.jpg';
import imageActivityFive from '../../images/activity_image_5.jpg';
import imageActivitySix from '../../images/activity_image_6.jpg';
import docKaufEinerEigentumswohnung from '../../docs/80001421_Kauf_einer_Eigentumswohnung_web.pdf';
import docImmobilienKauf from '../../docs/80001415_Immobilienkauf_web.pdf';
import docUnternehmensgruendung from '../../docs/80001416_Unternehmensgruendung_web.pdf';
import docSchenkunssteuer from '../../docs/80001417_Erbschaft_Schenkungsteuer_web.pdf';
import docErbenUndVererben from '../../docs/80001418_Erben_Vererben_web.pdf';
import docSchenken from '../../docs/80001419_Schenken_mit_warmer_Hand_web.pdf';
import docWasMussIchRegeln from '../../docs/80001422_Was_muss_ich_regeln_web.pdf';
import docBeizeitenVorsorgen from '../../docs/80001413_Beizeiten_vorsorgen_web.pdf';
import docStreitVermeiden from '../../docs/DNV_9-Brosch_Streit-vermeiden_Streit-beilegen-2012-Web.pdf';
import ReactPlayer from 'react-player/lazy';

const AreaOfActivity = () => {
  return (
    <div className='area-of-activity' id='activity'>
      <Heading heading='Tätigkeitsfelder' subHeading='Unsere Serviceleistungen für Sie' />

      <Container>
        <Row>
          <Col xs={12} md={6} xl={4}>
            <ActivityCard
              title='Grundstücke und Immobilien'
              text='Kaufen oder verkaufen, schenken oder finanzieren – bei allen Immobiliengeschäften ist der Notar gefragt.'
              variant='top'
              links={[
                {
                  sourceName: 'Kauf einer Eigentumswohnung (PDF in neuem Tab öffnen)',
                  source: docKaufEinerEigentumswohnung,
                },
                {
                  sourceName: 'Immobilienkauf und Finanzierung (PDF in neuem Tab öffnen)',
                  source: docImmobilienKauf,
                },
              ]}
              src={imageActivityOne}
            />
          </Col>

          <Col xs={12} md={6} xl={4}>
            <ActivityCard
              title='Handels- und Gesellschaftsrecht, Unternehmensnachfolge'
              text='Einzelunternehmen sind heutzutage sehr schnell im Handelsregister eingetragen, Gesellschaften auch.'
              variant='top'
              links={[
                {
                  sourceName: 'Handels- und Gesellschaftsrecht, Unternehmensnachfolge (PDF in neuem Tab öffnen)',
                  source: docUnternehmensgruendung,
                },
              ]}
              src={imageActivityTwo}
            />
          </Col>

          <Col xs={12} md={6} xl={4}>
            <ActivityCard
              title='Erbe und Schenkung'
              text='Jeder Weg geht einmal zu Ende. Wer nicht beizeiten vorsorgt, dem nimmt das Gesetz die Entscheidung über die Erbfolge ab.'
              variant='top'
              links={[
                {
                  sourceName:
                    'Was muss ich regeln, wenn eine mir nahestehende Person verstirbt (PDF in neuem Tab öffnen)',
                  source: docWasMussIchRegeln,
                },
                {
                  sourceName: 'Schenken zu Lebzeiten (PDF in neuem Tab öffnen)',
                  source: docSchenken,
                },
                {
                  sourceName: 'Erben und Vererben (PDF in neuem Tab öffnen)',
                  source: docErbenUndVererben,
                },
                {
                  sourceName: 'Erbschafts- und Schenkungsteuer (PDF in neuem Tab öffnen)',
                  source: docSchenkunssteuer,
                },
              ]}
              src={imageActivityThree}
            />
          </Col>

          <Col xs={12} md={6} xl={4}>
            <ActivityCard
              title='Vorsorge'
              text='Vor dem „Letzten Willen“ kommt der vorletzte. Egal in welchem Alter: Jeder kann beispielsweise durch Krankheit oder Unfall in eine Situation geraten, in der plötzlich andere das Ruder in die Hand nehmen müssen.'
              variant='top'
              links={[
                {
                  sourceName: 'Beizeiten vorsorgen (PDF in neuem Tab öffnen)',
                  source: docBeizeitenVorsorgen,
                },
              ]}
              src={imageActivityFour}
            />
          </Col>

          <Col xs={12} md={6} xl={4}>
            <ActivityCard
              title='Ehe, Partnerschaft, Familie'
              text='Eine Ehe oder Partnerschaft ändert alles. Kinder erst recht. Auch in juristischer Hinsicht. Die wenigsten kennen die rechtlichen Auswirkungen und können nicht beurteilen, ob es für ihre Situation notwendig ist, Vereinbarungen zu treffen.'
              variant='top'
              links={[]}
              src={imageActivityFive}
            />
          </Col>

          <Col xs={12} md={6} xl={4}>
            <ActivityCard
              title='Streit vermeiden, Streit beilegen'
              text='Wo Menschen sind, wird es immer Streit geben. Notare helfen durch Vorsorge überflüssigen und teuren Streit zu vermeiden.'
              variant='top'
              links={[
                {
                  sourceName: 'Streit vermeiden, Streit beilegen (PDF in neuem Tab öffnen)',
                  source: docStreitVermeiden,
                },
              ]}
              src={imageActivitySix}
            />
          </Col>
        </Row>
      </Container>

      <Container className='mb-5'>
        <Row className='justify-content-center'>
          <Col xs={12} sm={6} lg={4} className='react-player'>
            <div>
              <ReactPlayer controls width='100%' url='https://www.youtube.com/watch?v=77YGRwndFdY' />
            </div>
          </Col>

          <Col xs={12} sm={6} lg={4} className='react-player'>
            <div>
              <ReactPlayer controls width='100%' url='https://www.youtube.com/watch?v=VZHrFhnrV0s' />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AreaOfActivity;
